// PageMapper.tsx
import { Container } from '@almbrand/container';
import { Grid, GridCell } from '@almbrand/grid';
import { Modal } from '@almbrand/modal';
import { NotificationBanner } from 'components/2-molecules';
import { ContainerLayout } from 'components/4-habitats/ContainerLayout';
import { HeaderComponent } from 'components/4-habitats/HeaderComponent';
import { ThemeNames } from 'constantsValues/index';
import { HttpStatusCode } from 'constantsValues/statusCode';
import { PageContext } from 'context/PageContext';
import { useThemeName } from 'hooks/index';
import { useTrackPage } from 'hooks/useTrackPage';
import { useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchDocuments } from 'store/slices/documentSlice';
import { fetchParty } from 'store/slices/partySlice';
import { fetchPolicies } from 'store/slices/policiesSlice';

export const ContentPage: React.FC<PageModel> = () => {
	const dispatch = useAppDispatch();
	const partyData = useAppSelector((state) => state.party.data);
	const status = useAppSelector((state) => state.policies.status);
	const modal = useAppSelector((state) => state.modal);

	const pageContext = useContext(PageContext);
	const themeName = useThemeName();

	const isAlmbrand = themeName === ThemeNames.almbrand;
	const { headerContent, content, notificationBannerContent } = pageContext ?? {};

	useEffect(() => {
		if (status === HttpStatusCode.Idle) {
			dispatch(fetchPolicies());
			dispatch(fetchParty());
			dispatch(fetchDocuments());
		}
	}, [status, dispatch]);

	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
	}, [location.pathname]);

	useTrackPage(partyData?.last_name ? partyData?.last_name : partyData?.company_name);

	return (
		<>
			<div className='header-container'>
				<Container
					desktopWidth='fullWidth'
					tabletWidth='fullWidth'
					mobileWidth='fullWidth'
				>
					<Container
						desktopWidth='1600'
						tabletWidth='1280'
						mobileWidth='744'
					>
						<Grid>
							<GridCell>
								<HeaderComponent {...headerContent} />
							</GridCell>
						</Grid>
					</Container>
				</Container>
			</div>
			{notificationBannerContent && (
				<Container
					desktopWidth='1600'
					tabletWidth='1280'
					mobileWidth='744'
					className='pt-spacing-sm pb-spacing-sm'
				>
					<Grid>
						<GridCell>
							<NotificationBanner {...notificationBannerContent} />
						</GridCell>
					</Grid>
				</Container>
			)}

			<Container
				desktopWidth='fullWidth'
				tabletWidth='fullWidth'
				mobileWidth='fullWidth'
				className='content-container'
			>
				{content?.items?.map((component) => (
					<ContainerLayout
						component={component}
						key={component?.content?.contentId}
					/>
				))}
			</Container>
			{modal.displayModal && <Modal {...modal.modalProps} />}
		</>
	);
};
